/** Search global + Reports + Me update. */
import { api } from "@/lib/api";

// ── Global Search ──────────────────────────────────────────────────────
export interface SearchResults {
  jobs: { id: string; code: string; title: string; status: string }[];
  clients: { id: string; trade_name: string; cnpj: string }[];
  nerds: { id: string; legal_name: string | null; rank_score: number }[];
  invoices: { id: string; code: string; total: string; status: string }[];
}

export async function globalSearch(q: string): Promise<SearchResults> {
  const { data } = await api.get<SearchResults>("/v1/search", { params: { q } });
  return data;
}

// ── Reports ────────────────────────────────────────────────────────────
export interface RevenuePoint {
  month: string;
  revenue: string;
  count: number;
}

export interface TopClient {
  id: string;
  trade_name: string;
  corporate_name: string;
  jobs_count: number;
  revenue: string;
}

export interface TopNerdRevenue {
  id: string;
  legal_name: string | null;
  rank_score: number;
  jobs_count: number;
  payout: string;
}

export interface CategoryDistribution {
  category: string;
  count: number;
}

export interface SlaCompliance {
  on_time: number;
  late: number;
  compliance_pct: number;
}

export const reportsApi = {
  revenueMonthly: async (months = 12): Promise<RevenuePoint[]> => {
    const { data } = await api.get<RevenuePoint[]>("/v1/reports/revenue-monthly", { params: { months } });
    return data;
  },
  topClients: async (limit = 10): Promise<TopClient[]> => {
    const { data } = await api.get<TopClient[]>("/v1/reports/top-clients", { params: { limit } });
    return data;
  },
  topNerdsRevenue: async (limit = 10): Promise<TopNerdRevenue[]> => {
    const { data } = await api.get<TopNerdRevenue[]>("/v1/reports/top-nerds-revenue", { params: { limit } });
    return data;
  },
  jobsByCategory: async (): Promise<CategoryDistribution[]> => {
    const { data } = await api.get<CategoryDistribution[]>("/v1/reports/jobs-by-category");
    return data;
  },
  slaCompliance: async (): Promise<SlaCompliance> => {
    const { data } = await api.get<SlaCompliance>("/v1/reports/sla-compliance");
    return data;
  },
};

// ── Me update ─────────────────────────────────────────────────────────
export async function updateMe(body: { name?: string; phone?: string }): Promise<unknown> {
  const { data } = await api.patch("/v1/auth/me", body);
  return data;
}
